"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var utilities_1 = require("./utilities");
if (typeof __CULTURE__ !== 'undefined') {
    utilities_1.initializeCulture(__CULTURE__);
    exports.Culture = __CULTURE__;
}
else {
    if (!csod._services.disableAutoGlobalization) {
        if (csod.context && csod.context.playerBase) {
            loadGlobalizationScript();
        }
        else {
            throw 'Unable to locate globalization data source';
        }
    }
}
function loadGlobalizationScript() {
    var source = csod.context.playerBase + globalizationPath(csod.context.cultureName || '');
    return csod.utils
        .loadScript(source)
        .then(function () {
        utilities_1.initializeCulture(__CULTURE__);
        exports.Culture = __CULTURE__;
    })
        .catch(function () {
        throw 'Unable to load globalization values';
    });
}
exports.loadGlobalizationScript = loadGlobalizationScript;
//# sourceMappingURL=main.js.map
function globalizationPath(locale){ return 'player-globalization/1.1/' + locale + '.js';};


//////////////////
// WEBPACK FOOTER
// ../player-globalization/main.js
// module id = 175
// module chunks = 0 1